import React from 'react';
import error from '../../assets/404-error.svg';
import { SvgIconProps } from '@mui/material';

export const Pp404ErrorIcon: React.FC<SvgIconProps> = () => {
  return <img src={error} />;
};
